// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"Confirmation_confirmation__c5DeK","confirmation__cta":"Confirmation_confirmation__cta__fe7EO"};